import { SerializableError } from '@app/utils/SerializableError'

import type { ApiEmailToken } from '@app/packages/api/v2/types/entities'
import { asError } from '@app/packages/asError/asError'
import type { Result } from '@app/packages/Result/Result'
import { resultError, resultOk } from '@app/packages/Result/Result'

import { createReduxSlice } from '@app/store/redux_slice'
import { createThunk } from '@app/store/thunk'

const emailTokenSlice = createReduxSlice<Result<ApiEmailToken>>('email_token')

export const emailTokenStateSelector = emailTokenSlice.selector

export const setEmailTokenError = (error: Error) => emailTokenSlice.set(resultError(error))

export const verifyEmailToken = (email: string, token: string) =>
  createThunk(async dispatch => {
    const [{ postEmailTokensVerify }, { callV2Api }] = await Promise.all([
      import('@app/packages/api/v2/actions/email_tokens'),
      import('@app/store/actions/api'),
    ])
    const result: Result<ApiEmailToken> = await dispatch(callV2Api(postEmailTokensVerify(email, token)))
      .then(resp => resultOk(resp.data))
      .catch((e: unknown) => resultError(SerializableError.create(asError(e))))

    dispatch(emailTokenSlice.set(result))

    return result
  })
